import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-animated-progress-bar',
  templateUrl: './animated-progress-bar.component.html',
  styleUrls: ['./animated-progress-bar.component.scss']
})
export class AnimatedProgressBarComponent implements OnInit {

  @Input() text: string;
  @Input() height = '32px';
  @Input() width = '100%';

  constructor() { }

  ngOnInit(): void {
  }

}
